// O contrato de leitura servido pelo parser da plataforma.
//
// É literalmente o mesmo objecto que o módulo IDS constrói para o seu
// motor: as duas perguntas do contrato são as duas funções síncronas que
// o rawIfc já expõe. Está aqui em separado porque o assistente é um
// módulo independente e não deve importar as entranhas de outro.

import { rawIfc } from '@viewer/lib/rawIfc'
import type { IfcReadSource } from '@vn2r/ifc-read'

export function sourceFor(modelId: string): IfcReadSource {
  return {
    getLineIDsByType: (ifcTypeName) =>
      rawIfc.getLineIDsByType(modelId, ifcTypeName),
    getEntity: (expressID) =>
      rawIfc.getEntity(modelId, expressID) as Record<string, unknown> | null,
  }
}

/** Garante que o parser tem o modelo. É o único passo assíncrono das
 *  ferramentas: depois disto, tudo o que elas fazem é síncrono. */
/** Erro deliberado: um modelo aberto em Fragments (`.frag`) não traz o
 *  IFC, e todas as consultas leem o IFC. Sem isto, o parser não
 *  encontrava nada e as consultas respondiam "zero paredes" sobre um
 *  edifício cheio delas, que é a pior resposta possível: parece uma
 *  resposta. */
export class SemIfcError extends Error {
  constructor() {
    super(
      'Este modelo foi aberto em Fragments (.frag) e não traz o IFC por ' +
        'trás. As consultas ao modelo leem o IFC, por isso não consigo ' +
        'responder a esta pergunta sem inventar. Abre o .ifc original e ' +
        'volta a perguntar.',
    )
    this.name = 'SemIfcError'
  }
}

export async function ensureLoaded(modelId: string): Promise<void> {
  if (rawIfc.hasModel(modelId)) return
  if (!rawIfc.hasCachedBytes(modelId)) throw new SemIfcError()
  await rawIfc.loadModel(modelId)
}
